import React, { Fragment, useEffect, useState, useCallback } from 'react';
import { translate } from '../../../../Services/translation';
import { post } from '../../../../Services/http';
import { NavLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Pagination from '../../../../Components/Pagination';
import { calculatePager } from '../../../../Services/Pagination.service';

const OrderHistory = (props) => {
    const [orderList, setorderList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pager, setPager] = useState({});
    const pageSize = 5;
    const [totalOrderCount, settotalOrderCount] = useState();

    const dispatch = useDispatch();

    useEffect(() => {
        if (props.customerId) {
            queryOrders();
        }        
    }, [props.customerId]);

    const queryOrders = () => {
        if (props.customerId) {
            post(`/api/customer/getorders`, {
                customerId: props.customerId,
                pageIndex: currentPage,
                pageSize: 5,
            })
            .then((response) => response.json())
            .then((result) => {
                setorderList(result);
                settotalOrderCount(result.totalCount);
            });
        }        
    }

    useEffect(() => {
        setPager(calculatePager(totalOrderCount, currentPage, pageSize));
    }, [totalOrderCount, currentPage, pageSize]);

    const changePageIndex = useCallback(
        (pageIndex) => {
            if (pageIndex !== currentPage) {
                setCurrentPage(pageIndex);                
            }
        },
        [currentPage, dispatch]
    );

    const getClinicalPartText = (order) => {
        if (!order.isSubscriptionOrder) return "";
        return translate(order.clinicalPartActive 
            ? 'coptikk.subscriptionlist.clinicalexamination.active' 
            : 'coptikk.subscriptionlist.clinicalexamination.inactive'
        );
    }

    useEffect(() => {
        queryOrders();
    }, [currentPage])

    return (
        <Fragment>
            <div className='admin-portal__customer-detail'>
                <div className='detail-wrapper'>
                    <p className='sub-title'>{translate('coptikk.adminportal.customer.orders')}</p>
                    <div className="order-table">
                        <div className="order-table__header-row">
                            <div className="columns medium-1 header-item">
                                {translate('coptikk.adminportal.customer.orders.nr')}
                            </div>
                            <div className="columns medium-2 header-item">
                                {translate('coptikk.adminportal.customer.orders.ordernumber')}
                            </div>
                            <div className="columns medium-2 header-item">
                                {translate('coptikk.adminportal.customer.orders.date')}
                            </div>
                            <div className="columns medium-1 header-item">
                                {translate('coptikk.adminportal.customer.orders.total')}
                            </div>  
                            <div className="columns medium-1 header-item">
                                {translate('coptikk.adminportal.customer.orders.status')}
                            </div>
                            <div className="columns medium-1 header-item">
                                {translate('coptikk.subscriptionlist.clinicalexamination.header')}
                            </div>
                            <div className="columns medium-2 header-item">
                                {translate("coptikk.adminportal.sales.ordertype")}
                            </div>
                            <div className="columns medium-2 header-item"></div>                      
                        </div>
                        {orderList.orders && orderList.orders.map((item, index) => {
                            return <div className="order-table__order-row">
                            <div className="columns medium-1 order-item">
                                <p className='show-for-small'>
                                    {translate('coptikk.adminportal.customer.orders.nr')}:
                                </p>
                                {(currentPage ? (currentPage - 1) * 5 : 0) + index + 1}                                
                            </div>
                            <div className="columns medium-2 order-item">
                                <p className='show-for-small'>
                                    {translate('coptikk.adminportal.customer.orders.ordernumber')}:
                                </p>
                                 {item.externalOrderID}                                
                            </div>
                            <div className="columns medium-2 order-item">
                                <p className='show-for-small'>
                                    {translate('coptikk.adminportal.customer.orders.date')}:
                                </p>
                                 {item.orderDate}                                
                            </div>
                            <div className="columns medium-1 order-item">
                                <p className='show-for-small'>
                                    {translate('coptikk.adminportal.customer.orders.total')}:
                                </p>
                                 {item.orderGrandTotal}                               
                            </div>
                            <div className="columns medium-1 order-item">
                                <p className='show-for-small'>
                                    {translate('coptikk.adminportal.customer.orders.status')}:
                                </p>    
                                 {item.status}                                
                            </div>
                            <div className="columns medium-1 order-item">
                                <p className='show-for-small'>
                                    {translate('coptikk.subscriptionlist.clinicalexamination.header')}:
                                </p>
                                {getClinicalPartText(item)}
                            </div>
                            <div className="columns medium-2 order-item">
                                <p className='show-for-small'>
                                    {translate('coptikk.adminportal.sales.ordertype')}:
                                </p>    
                                 {item.isSubscriptionOrder ? translate("coptikk.product.subscription") : translate("coptikk.product.onlyonetimeshop")}                                
                            </div>
                            <div className="columns medium-2 order-item text--right">
                                <NavLink to={"/orderdetail?orderId=" + item.orderId + "&redirectTo=customerdetails"} className='button'>{translate('coptikk.adminportal.order.gotoorder')}</NavLink>                              
                            </div>
                        </div> 
                        })}                        
                    </div>
                    <Pagination model={pager} onChange={changePageIndex} />
                </div>
            </div>
        </Fragment>
    )
}

export default OrderHistory;